
import React, {useEffect, useState} from "react";
import {
  useHistory,
  useLocation,
  Link
} from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { Col, Row, Form, Card, Button, Image, Container, InputGroup } from 'react-bootstrap';

import BgImage from "../assets/img/vite/vitebackground.png";
import Logo from "../assets/img/vite/ViteLogoOnly.png";
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useAuth } from "../hooks/auth.hook";
import LoadingComponent from "../components/LoadingComponent";
import { errorToast, successToast } from "../utils/toast";


function SignIn() {
  let auth = useAuth();
  let history = useHistory();
  let location = useLocation();
  let { from } = location.state || { from: { pathname: "/dashboard" } };
  let {valid_email, success_restart, success_request } = location.state || {valid_email: null, success_restart: null, success_request: null }

  const loginSchema = yup.object({
    email: yup.string().email("Debes ingresar un correo electrónico válido").max(320).required('El correo electrónico no puede estar vacío')
    .matches(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, 'Ingresa un correo de electrónico válido válido'),
    password: yup.string().max(128).required('La contraseña no puede estar vacía')
  });

  const handleLoginSubmit = (values, { setSubmitting }) => {
    //start loader here
    setSubmitting(true);
    setIsLoading(true);
    auth.signin(values.email, values.password)
        .then((result) => {
            // result is true always
              history.replace("/dashboard");
        })
        .catch((error) => {
          //remove loader
          setIsLoading(false);
          console.log(error);
          errorToast(error);
        })
        .finally(() => {
            setSubmitting(false);
            setIsLoading(false);
        });
  };
  const formik = useFormik({
    initialValues: {  email: '', password: ''},
    validationSchema: loginSchema,
    onSubmit: handleLoginSubmit,
  });
  const [isLoading, setIsLoading] = useState(false);
  
  useEffect(() => {
    if(valid_email !== null){
      if(valid_email){
        successToast("¡El correo electrónico ha sido verificado con éxito!")
      }else{
        errorToast("El correo electrónico no ha podido ser verificado")
      }
    }
    if(success_restart !== null){
      if(success_restart){
        successToast("¡Has restablicido tu contraseña con éxito!")
      }
    }
    if(success_request !== null){
        successToast("¡El correo de restablecimiento ha sido enviado!")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <main>
      <section className="d-flex align-items-center">
        <Container fluid style={{ backgroundImage: `url(${BgImage})`, backgroundRepeat: `repeat`, height: `100vh`, width: `100vw` }}>
          <Container className=" my-5 mt-lg-6 mb-lg-5">
          <Row className="justify-content-center form-bg-image">
            <Col xs={12} className="d-flex align-items-center justify-content-center">
              {isLoading && (
                  <>
                    <LoadingComponent className="d-flex align-items-center justify-content-center fmxw-500"></LoadingComponent>
                  </>
              )}
              <div className="bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <div className="d-flex align-items-center justify-content-center">
                    <Image src={Logo} style={{width: `240px`}}></Image>
                </div>
                <div className="text-center text-md-center mb-4 mt-md-0">
                  <h3 className="mb-0">Bienvenido a ViteCapital TradeCalc</h3>
                </div>
                <Form className="mt-4" onSubmit={formik.handleSubmit} method="post">
                  <Form.Group className="mb-4">
                    <Form.Label>Correo electrónico</Form.Label>
                       <InputGroup>
                         <Form.Control
                            required 
                            id="email"
                            type="text" 
                            maxLength="120"
                            placeholder="micorreo@vitecp.com"
                            className={` ${(formik.touched.email && formik.errors.email) ? "invalid" : ""} ${(formik.touched.email && !formik.errors.email) ? "valid" : ""}`}
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}/>
                       </InputGroup>
                            {formik.touched.email && formik.errors.email  &&
                                <div style={{ position: "absolute", display: "flex" }}>
                                  <small className="invalid-feedback" style={{ display: "inline-block" }}> <FontAwesomeIcon icon={faExclamationCircle} /> {formik.errors.email}</small>
                                </div>
                              }
                  </Form.Group>
                  <Form.Group>
                    <Form.Group className="mb-4">
                      <Form.Label>Contraseña</Form.Label>
                         <InputGroup>
                           <Form.Control
                              required 
                              id="password"
                              type="password" 
                              maxLength="128"
                              placeholder="contraseña"
                              className={` ${(formik.touched.password && formik.errors.password) ? "invalid" : ""} ${(formik.touched.password && !formik.errors.password) ? "valid" : ""}`}
                              value={formik.values.password}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}/>
                         </InputGroup>
                              {formik.touched.password && formik.errors.password  &&
                                  <div style={{ position: "absolute", display: "flex" }}>
                                    <small className="invalid-feedback" style={{ display: "inline-block" }}> <FontAwesomeIcon icon={faExclamationCircle} /> {formik.errors.password}</small>
                                  </div>
                                }
                    </Form.Group>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <Card.Link className="small text-end" as={Link} to={"/recover"} >¿Olvidaste tu contraseña?</Card.Link>
                    </div>
                  </Form.Group>
                  <Button variant="primary" type="submit" className="w-100">
                    Ingresar
                  </Button>
                </Form>
                <div className="d-flex justify-content-center align-items-center mt-4">
                  <span className="fw-normal">
                    ¿No estás registrado?
                    <Card.Link as={Link} to={"/register"} className="fw-bold">
                      {` Crear cuenta `}
                    </Card.Link>
                  </span>
                </div>
              </div>
            </Col>
          </Row>
          </Container>
        </Container>
      </section>
    </main>
  );
};

export default SignIn